const TAB_FOCUS_CLASS = 'keyfocus';
const CODE_TAB = 'Tab';

/**
 * Handle logic to change state to keyboard navigation.
 */
function onFocusInHandler() {
    document.body.classList.add(TAB_FOCUS_CLASS);
    document.body.removeEventListener('focusin', onFocusInHandler);
}

/**
 * Handle logic to change state to keyboard navigation.
 */
function onFocusOutHandler() {
    document.body.classList.remove(TAB_FOCUS_CLASS);
    document.body.removeEventListener('focusout', onFocusOutHandler);
}

/**
 * Handle logic to remove keyboard navigation state after onTabKeyPress to default.
 */
function onClickHandler() {
    document.body.classList.remove(TAB_FOCUS_CLASS);
    document.body.removeEventListener('click', onClickHandler);
}

/**
 * Main logic: call differ actions onTabKeyPress and onClick
 */
function smartKeyboardFocus() {
    document.addEventListener('keydown', function (event) {
        if (event.key !== CODE_TAB) {
            return;
        }

        document.body.addEventListener('focusout', onFocusOutHandler);
        document.body.addEventListener('focusin', onFocusInHandler);
        document.body.addEventListener('click', onClickHandler);
    });
}

module.exports = {
    init: smartKeyboardFocus,
    onFocusInHandler: onFocusInHandler,
    onClickHandler: onClickHandler,
    smartKeyboardFocus: smartKeyboardFocus
};
